/**
 *  Filename ....: agencydefinition.component.ts
 *  Created by ..: ianday
 *  on Date .....: 10/9/23
 **/
import {Component, HostListener, OnInit} from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { Agencies } from 'src/app/models/agencies';
import { AgenciesService } from 'src/app/services/agencies.service';
import { Settings } from 'src/app/services/settings';
import { TransactionHistoryService } from 'src/app/services/transactionhistory.service';
import { UserService } from 'src/app/services/user.service';
import { ValidationResult } from '../../../models/validation-result';
import {ServiceDefService} from "../../../services/servicedef.service";

export class dataRecord {
	public id: string;
	public description: string;
	constructor(idVal: string, desc:string) {
		this.id = idVal;
		this.description = desc;
	}
}

@Component({
	selector: 'app-agencydefinition',
	templateUrl: './agencydefinition.component.html',
	styleUrls: ['./agencydefinition.component.css']
})

export class AgencyDefinitionComponent implements OnInit {
	public formTitle = 'Agency Definition';
	public strErr = '';
	public isEditing = false;
	public id = 0;
	public agencyCode: string;
	public agencyName: string;
	public address1: string;
	public address2: string;
	public city: string;
	public state: string;
	public zipCode: string;
	public county: any | null = '';
	public primaryContact: any | null = '';
	public secondContact: any | null = '';
	public phoneNumber: any | null = '';
	public emailAddress: any | null = '';
	public phoneNumber2: any | null = '';
	public emailAddress2: any | null = '';
	public activeStatus: string | null = '';
	public countyList: any;
	public hoursOfOperation: string = '';

	public agencyRecord: Agencies;
	public historyRecord: Agencies;
	public selectedRecord: Agencies;

	public displayAgencyUsers = false;
	public headerUsers: string;
	public userCount: number;
	
	editButtonVisibility= false;
	statusVisibility = false;
	statusActive = false;
	usersVisibility = false;
	usersActive = false;

	constructor(private agenciesService: AgenciesService,
				 private userService: UserService,
				 private txService: TransactionHistoryService,
				 public serviceDefService:ServiceDefService) {
		this.selectedRecord = new Agencies();
	}

	@HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		this.strErr = '';
	}

	ngOnInit() {

		this.userCount = 0;
		this.loadRegionsList();
		if(Settings.getInstance().hasPrivilege('AGENCY_DETAILS', "WRITE")) {
			this.editButtonVisibility = true;
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_DETAILS_STATUS', "READ")) {
			this.statusVisibility = true;
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_DETAILS_STATUS', "WRITE")) {
			this.statusActive = true;
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_DETAILS_USER_MGMT', "SHOW")) {
			this.usersVisibility = true;
		}
		if(Settings.getInstance().hasPrivilege('AGENCY_DETAILS_USER_LIST', "SHOW")) {
			this.usersActive = true;
		}
	}
	public loadRegionsList() {
		this.serviceDefService.getAllRegions().subscribe(
			(result) => {
				Settings.getInstance().regionsList = result;
				this.countyList = Settings.getInstance().getCountyDataSource(false);
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve region data from the service');
			}
		)
	}
	public ngAfterContentInit() {
		this.queryRecords();
	}

	queryRecords() {

		this.agenciesService.getAgencyById(Settings.getInstance().loggedInUser.agencyId).subscribe(
			(data) => {
				this.agencyRecord = data;
				this.historyRecord = data;
				this.displayDetails(this.agencyRecord);
				this.userService.getUserCountByAgencyId(Settings.getInstance().loggedInUser.agencyId).subscribe(
					(data2) => {
						if (data2) {
							this.userCount = data2;
						}
					},
					(error2) => {
						this.strErr = 'Error: The server could not fetch user count';
						return;
					});
			},
			(error) => {
				this.strErr = 'Error: The server could not fetch agency details';
				return;
			});
	}
	displayDetails(rec: Agencies) {
		if (!rec) {
			return;
		}
		this.id = rec.id;
		this.agencyName = rec.agencyName;
		this.agencyCode = rec.agencyCode;
		this.address1 = rec.address1;
		this.address2 = rec.address2;
		this.city = rec.city;
		this.county = rec.county;
		this.emailAddress = rec.emailAddress;
		this.primaryContact = rec.primaryContact;
		this.secondContact = rec.secondaryContact;
		this.emailAddress2 = rec.emailAddressSecondary;
		this.state = rec.state;
		this.phoneNumber = rec.phoneNumber;
		this.phoneNumber2 = rec.phoneNumberSecondary;
		this.zipCode = rec.zipCode;
		this.hoursOfOperation = rec.hoursOfOperation;
		this.activeStatus = rec.activeStatus.toString();
		this.headerUsers = 'Agency users: ' + this.agencyName;
	}
	modifyClickHandler() {
		this.isEditing = true;
	}
	cancelClickHandler() {
		this.agencyRecord = this.historyRecord;
		this.displayDetails(this.agencyRecord);
		this.isEditing = false;
		this.strErr = '';
	}
	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}
	saveClickHandler() {
		this.strErr = '';

		this.selectedRecord = new Agencies();
		this.selectedRecord.id = this.id;
		this.selectedRecord.agencyName = DwUtils.capitalize(this.agencyName);
		this.selectedRecord.agencyCode = this.agencyCode;
		this.selectedRecord.address1 = DwUtils.capitalize(this.address1);
		this.selectedRecord.address2 = DwUtils.capitalize(this.address2);
		this.selectedRecord.city = DwUtils.capitalize(this.city);
		this.selectedRecord.state = this.state.toUpperCase();
		this.selectedRecord.zipCode = this.zipCode.toString();
		this.selectedRecord.county = DwUtils.capitalize(this.county);
		this.selectedRecord.activeStatus = this.activeStatus;
		this.selectedRecord.primaryContact = DwUtils.capitalize(this.primaryContact);
		this.selectedRecord.secondaryContact = DwUtils.capitalize(this.secondContact);
		this.selectedRecord.phoneNumber = this.phoneNumber;
		this.selectedRecord.emailAddress = this.emailAddress;
		this.selectedRecord.phoneNumberSecondary = this.phoneNumber2;
		this.selectedRecord.emailAddressSecondary = this.emailAddress2;
		this.selectedRecord.hoursOfOperation = this.hoursOfOperation;

		this.strErr = '';

		if (!this.validateFields()) {
			return;
		}

		this.agenciesService.updateAgencies(this.selectedRecord).subscribe(
			(data) => {
				this.isEditing = false;
			},
			(error) => {
				this.strErr = 'Error: The server could not update this record';
				this.agencyRecord = this.historyRecord;
				return;
			});

		/*** add a transaction history record ***/
		this.txService.updateTransactionHistory(this.historyRecord,
			this.agencyRecord, 'Agencies', this.agencyRecord.id);

	}
	openAgencyUsersDialog() {
		this.displayAgencyUsers = true;
	}
}



